import { Component } from '@angular/core';

/**
 * Generated class for the TagCloudComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'tag-cloud',
  templateUrl: 'tag-cloud.html'
})
export class TagCloudComponent {

  text: string;

  constructor() {
    this.text = 'Hello World';
  }

}



// WEBPACK FOOTER //
// ./src/components/tag-cloud/tag-cloud.ts